import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { withStyle } from 'styletron-react';
import { getSpacing } from '../../const/spacing';
import { layoutBasePropsToStyledProps, StyledLayoutBase } from './LayoutBase';
import { getAlignItems } from './helpers/getAlignItems';
import { getJustifyContent } from './helpers/getJustifyContent';
const StyledFlexContainer = withStyle(StyledLayoutBase, (p) => ({
    display: 'flex',
    flexDirection: p.$direction,
    flexWrap: p.$wrap ? 'wrap' : 'nowrap',
    alignItems: getAlignItems(p.$direction, p.$horizontalAlign, p.$verticalAlign),
    justifyContent: getJustifyContent(p.$direction, p.$horizontalAlign, p.$verticalAlign),
    gap: getSpacing(p.$gap),
}));
export const FlexContainer = forwardRef(({ children, direction = 'row', wrap = false, horizontalAlign: horizontalAlignPassed, verticalAlign: verticalAlignPassed, center = false, gap = '0', id, ...layoutBaseProps }, ref) => {
    const defaultAlign = center ? 'center' : 'none';
    const horizontalAlign = horizontalAlignPassed ?? defaultAlign;
    const verticalAlign = verticalAlignPassed ?? defaultAlign;
    return (_jsx(StyledFlexContainer, { ref: ref, $direction: direction, $wrap: wrap, $horizontalAlign: horizontalAlign, $verticalAlign: verticalAlign, $gap: gap, id: id, ...layoutBasePropsToStyledProps(layoutBaseProps), children: children }));
});
